"use client";

import { Button } from "@universe/ui/components/button";
import { cn } from "@universe/ui/lib/utils";

import CompanyLogo from "./company-logo";

interface GlobalErrorPageProps {
  title: string;
  subtitle?: string;
  cta: string;
  onLogoClick?: () => void;
  onClick?: () => void;
  onLogout?: () => void;
  isInAppError?: boolean;
}

export default function GlobalErrorPage({
  title,
  subtitle,
  cta,
  onLogoClick,
  onClick,
  onLogout,
  isInAppError = false,
}: GlobalErrorPageProps) {
  return (
    <div>
      <div
        className={cn(
          "flex flex-col items-center justify-center gap-4",
          !isInAppError && "h-screen"
        )}
      >
        {!isInAppError && (
          <div className="max-w-[300px]">
            <CompanyLogo
              id="globalLoaderSpinner"
              width={200}
              height={180}
              variant="default"
              onClick={onLogoClick}
            />
          </div>
        )}
        <h2 className="text-xl font-semibold">{title}</h2>
        {subtitle && (
          <p className="text-base text-center max-w-sm">{subtitle}</p>
        )}
        <Button
          size="lg"
          className="text-base mt-4"
          onClick={onClick || (() => window.location.reload())}
        >
          {cta}
        </Button>
        {onLogout && (
          <Button
            variant="outline"
            size="lg"
            className="text-base"
            onClick={onLogout}
          >
            Log out
          </Button>
        )}
      </div>
    </div>
  );
}
